import { ExpressionItem } from 'new/components/SplitDataSet/ExpressionsEditor';
import { ValueItem } from 'new/components/SplitDataSet/ValuesEditor';
import * as actionTypes from '../../constants/actionTypes';

export const splitterSetMode = (mode: string) => {
  return {
    type: actionTypes.SPLITTER_SET_MODE,
    payload: {
      mode,
    },
  };
};

export const splitterSetFallback = (fallback: string) => {
  return {
    type: actionTypes.SPLITTER_SET_FALLBACK,
    payload: {
      fallback,
    },
  };
};

export const splitterSetExpressions = (expressions: ExpressionItem[]) => {
  return {
    type: actionTypes.SPLITTER_SET_EXPRESSIONS,
    payload: {
      expressions,
    },
  };
};

export const splitterSetAttr = (attr: string | null) => {
  return {
    type: actionTypes.SPLITTER_SET_ATTR,
    payload: {
      attr,
    },
  };
};

export const splitterSetValues = (values: ValueItem[]) => {
  return {
    type: actionTypes.SPLITTER_SET_VALUES,
    payload: {
      values,
    },
  };
};

export const splitterSetLoading = (loading: boolean) => {
  return {
    type: actionTypes.SPLITTER_SET_LOADING,
    payload: {
      loading,
    },
  };
};

export const splitterSetLastTxPayload = (transform: any) => {
  return {
    type: actionTypes.SPLITTER_SET_LAST_TX_PAYLOAD,
    payload: {
      transform,
    },
  };
};

export const splitterReset = () => {
  return {
    type: actionTypes.SPLITTER_RESET,
  };
};
